import { styled } from '@/stitches.config';

interface ColorIndicatorProps {
  colors: string[];
}

const DOT_SIZE = 15;

export function ColorIndicator({ colors }: ColorIndicatorProps) {
  return (
    <Container>
      {colors.map((color, index) => (
        <ColorDot
          key={`${index}-${color}`}
          css={{
            backgroundColor: color,
          }}
        />
      ))}
    </Container>
  );
}

const Container = styled('div', {
  height: DOT_SIZE,
  display: 'flex',
  zIndex: 9,
});

const ColorDot = styled('div', {
  height: '100%',
  width: DOT_SIZE,
  borderRadius: '50%',
  marginRight: '15px',

  '&:last-of-type': {
    marginRight: 0,
  },
});
